// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
// 引入路由
import router from './router';
// 引入状态管理
import store from './vuex/store';
import tools from './utils/tools';
// 引入element UI
import ElementUI from 'element-ui';
import './assets/theme/index.css';
// 引入icon
import './assets/icon/iconfont.css'
// 公共样式
import './assets/css/xunyou.css'
// 引入echarts
import echarts from 'echarts'
import Config from './utils/config';
// 空状态组件
import Empty from './components/empty';
Vue.component('empty', Empty);

Vue.prototype.$echarts = echarts

import axios from 'axios';

Vue.prototype.$axios = axios;
Vue.prototype.$code = Config.$CODE;

Vue.config.productionTip = false;

// Vue.prototype.$baseUrl = 'http://122.51.226.11:80';
// Vue.prototype.$baseUrl = 'http://106.14.141.120:7101'
Vue.prototype.$baseUrl = '/proxy';
// Vue.prototype.$baseUrl = 'https://www.xunyoushop.com/center';
Vue.prototype.$tools = tools;
// Vue.prototype.$IM_URL = 'http://106.14.141.120:7103/index';
Vue.prototype.$IM_URL = 'https://im.r-e-go.com/index';


// 使用element UI
Vue.use(ElementUI);
//地图定位组件

import VueAMap from 'vue-amap';

Vue.use(VueAMap);

VueAMap.initAMapApiLoader({

  key: 'ebd1337d8177f94f8515451a9023f23d',
  plugin: [
    'AMap.Autocomplete',
    'AMap.PlaceSearch',
    'AMap.Scale',
    'AMap.OverView',
    'AMap.ToolBar',
    'AMap.MapType',
    'AMap.PolyEditor',
    'AMap.CircleEditor',
    'AMap.Geolocation'
  ],
  // 默认高德 sdk 版本为 1.4.4
  v: '1.4.4'
});
// 过滤器
import * as custom from './utils/util'
Vue.prototype.$utils = custom;

Object.keys(custom).forEach(key => {
  Vue.filter(key, custom[key])
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store, //使用store vuex状态管理
  components: {App},
  template: '<App/>',
  data: {
    // 空的实例放到根组件下，所有的子组件都能调用
    Bus: new Vue()
  }
})



// WEBPACK FOOTER //
// ./src/main.js